import { render, staticRenderFns } from "./DuplicateContactsWarning.vue?vue&type=template&id=07497c1c&"
import script from "./DuplicateContactsWarning.vue?vue&type=script&lang=js&"
export * from "./DuplicateContactsWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports